import "./footer.css";
import logo from "assets/images/others/logo.png"
import { useState } from "react";
import { ChevronLeft } from '@material-ui/icons';

const Footer = () => {
  const [termsModal, setTermsModal] = useState(false);
  const handleModal = () => {
    if(termsModal){
      setTermsModal(false);
      document.body.classList.remove('no-scroll');
    }else{
      setTermsModal(true);
      document.body.classList.add('no-scroll');
    }
  }
  return (
    <>
      <footer className="footer">
        <div className="container ft-top-sec row">
          <div className="infos">
            <div className="picto"><img src={logo} alt="Business Ape Club" /></div>
            <p className="typo">BUSINESS APE CLUB</p>
            <p className="text-pr">businessapeclub@gmail.com</p>
          </div>
          <div className="f-right row ">
            <div className="social row">
              <div className="link">
                <a
                  href="https://www.instagram.com/businessapeclub/"
                  target="_blank" rel="noopener noreferrer"
                  className="insta row"
                >.</a>
              </div>
              <div className="link">
                <a
                  href="https://twitter.com/BusinessApeClub"
                  target="_blank" rel="noopener noreferrer"
                  className="twitter row"
                >.</a>
              </div>
              <div className="link">
                <a
                  href="https://discord.gg/eqWG6CuyqC"
                  target="_blank" rel="noopener noreferrer"
                  className="discord row"
                >.</a>
              </div>
              <div className="link">
                <a
                  href="https://www.tiktok.com/@businessapeclub?"
                  target="_blank" rel="noopener noreferrer"
                  className="tiktok row"
                >.</a>
              </div>
            </div>
            <button onClick={handleModal} className="f-terms-btn">Terms & Conditions</button>
          </div>
        </div>
        <div className="container">
          <p className="copyright">©2021 &nbsp; Business Ape Club</p>
        </div>
      </footer>

      {termsModal &&
        <>
          {/* <div onClick={handleModal} className="backdrop-sidebar"></div> */}
          <div className="model-wrapper">
            <div className="model-header">
              <div className="model-container row">
                <div className="model-close-btn" onClick={handleModal}>
                  <ChevronLeft className="ft-chev" />
                </div>
                <div className="modal-logo row">
                  <img src={logo} alt="" />
                  <h4 className="modal-logo-text">
                    Business Ape Club
                  </h4>
                </div>
              </div>
            </div>
            <div className="model-container">

              <div className="modal-body">
                <h3 className="terms-head">TERMS & CONDITIONS</h3>
                <p>
                  Business Ape Club (BAC) is a collection of digital artwork (NFTs) running on the Ethereum network blockchain. This website only acts as an interface for users to access our digital art works (NFTs). It is not by any means the responsibility of the BAC TEAM for the safety and management of users and their personal Ethereum wallet, the validations of all transactions, and contracts related to and generated by the Business Ape Club. Be aware that the Business Ape Club smart contract is deployed on the Ethereum network, meaning all transactions will not be able to be reversed, undone or restored in any form.
                </p>
                <h3 className="terms-head">OwnerShip</h3>
                <p>
                  Each Business Ape NFT is on the Ethereum block chain. When you purchase the NFT, you outright own the artwork completely and the rights to the underlying Business Ape. Ownership of the NFT is mediated entirely and only by the Smart Contract and the Ethereum Network, therefore at no time may we seize, freeze or otherwise modify ownership of the Business Ape.
                </p>
                <p>
                  Personal Use. Subject to your continued compliance with these Terms, businessapeclub.com grants you worldwide, royalty free license to use, copy and display the purchase Business Ape(s), along with any extension that you choose to create or use, solely for the following purposes; (i) for you own personal non commercial use; (ii) as a part of a marketplace that permits the purchase and sales of your Business Ape / NFT, provided that the marketplace cryptographically verifies each Business Ape owner’s rights to display the art of their Business Ape to ensure that only the actual owner can display the Art; or (iii) as part of a third party website or application that permits the inclusion, involvement, or participation of your Business Ape, provided that the website/application cryptographically verifies each Business Ape owner’s rights to display the art for their Business Ape to ensure that only the actual owner can display the Art, and provided that the Art is no longer visible once the owner of the Business Ape leaves the website/application,
                </p>
                <p>
                  Commercial Use. Subject to your continued compliance with these Terms, BusinessApeClub.com grants you an unlimited, worldwide license to use, copy, and display the purchased Business Ape for the purpose of creating derivative works based upon the Business Ape (“Commercial Use”). Examples of such Commercial Use would be the use of the Business Ape to produce and sell merchandise products
                </p>
              </div>
            </div>

          </div>
        </>
      }
    </>
  );
};

export default Footer;
